export enum WatchlistStatusType {
    Draft = 1,
    Current = 2,
    Historic = 3,
}

export const WatchlistStatusTypeOptions = [
    {
        id: WatchlistStatusType.Draft,
        name: 'Draft',
    },
    {
        id: WatchlistStatusType.Current,
        name: 'Current',
    },
    {
        id: WatchlistStatusType.Historic,
        name: 'Historic',
    },
];
